"use client";

import { useTranslations } from "next-intl";
import { FooterLocaleFlag } from "./footer-region-flags";
import { LanguageSelect } from "./language-switcher";
import type { Locale } from "@/config/locale";

const compactSelectClass =
	"h-8 min-h-0 w-auto min-w-0 max-w-[10rem] shrink cursor-pointer appearance-none border-0 bg-transparent py-0 pl-1 pr-6 text-xs font-medium leading-none text-foreground " +
	"rounded-none focus:outline-none focus:ring-0 focus:ring-offset-0 " +
	"focus-visible:outline-none focus-visible:ring-0";

export function FooterLocaleRegionControls({
	locale,
	enabledLocales,
}: {
	locale: Locale;
	enabledLocales: readonly Locale[];
}) {
	const t = useTranslations("footer");
	return (
		<div className="flex w-full max-w-md flex-col gap-3 sm:max-w-none sm:items-end">
			<div className="flex w-full flex-wrap items-center gap-x-2 gap-y-1 sm:w-auto sm:justify-end">
				<p className="shrink-0 text-xs font-medium text-muted-foreground sm:text-right">
					{t("languageLabel")}
				</p>
				<div className="border-border/60 inline-flex min-h-8 min-w-0 max-w-full items-stretch overflow-hidden border bg-background transition-colors hover:border-border">
					<div className="border-border/60 bg-muted/25 flex shrink-0 items-center justify-center border-r px-1.5">
						<FooterLocaleFlag locale={locale} compact />
					</div>
					<LanguageSelect
						id="footer-locale-select"
						currentLocale={locale}
						enabledLocales={enabledLocales}
						showOptionEmoji={false}
						className={compactSelectClass}
						aria-label={t("languageLabel")}
					/>
				</div>
			</div>
		</div>
	);
}
